import React, { useEffect, useState, useContext } from "react";
import { Dropdown, Badge } from "antd";
import { useSelector } from "react-redux";
import { BellOutlined, NotificationOutlined } from "@ant-design/icons";
import { NotificationContext } from "../Notification";
import {
  DropDownNotificaton,
  NotificationCard,
  NotificationTabs,
} from "./index.style";

const Notification = React.memo(() => {
  // state
  const [m2mMessage, setm2mMessage] = useState([]);
  const [m2mCount, setM2mCount] = useState(0);

  const { showNotification } = useContext(NotificationContext);

  // redux
  const m2mAlert = useSelector((state) => state?.globleSlice?.m2mAlert);
  const Notification = useSelector(
    (state) => state?.globleSlice?.notification?.normal
  );

  // life cycle
  useEffect(() => {
    if (Notification) {
      const updatedM2m = Notification?.map((el, index) => {
        return {
          ...el,
          key: index,
          label: <span>{el?.message}</span>,
          icon: <NotificationOutlined />,
        };
      });
      setm2mMessage(updatedM2m);
      setM2mCount(updatedM2m?.length);

      console.log(Notification?.length);
      if (Notification?.length === 1) {
        showNotification({
          type: "info",
          config: {
            message: Notification[Notification?.length - 1]?.type,
            description: Notification[Notification?.length - 1]?.message,
          },
        });
      }
    }
  }, [Notification]);

  // function
  const handleMenuClick = ({ key, item }) => {
    console.log("value", key, "name", item?.props);
  };

  const notificationProps = {
    items: m2mMessage,
    onClick: handleMenuClick,
  };

  const handleDropdownVisibleChange = (visible) => {
    if (!visible) {
      setM2mCount(0);
    }
  };

  const onChangeTab = () => {};

  const tabList = [
    {
      key: "1",
      label: "High",
      children: (
        <div>
          {m2mMessage?.map((el) => (
            <NotificationCard title={<p>{el?.type}</p>} variant="outlined">
              <p>{el?.message}</p>
            </NotificationCard>
          ))}
        </div>
      ),
    },
    {
      key: "2",
      label: "Midium",
      children: "Content of Tab Pane 2",
    },
    {
      key: "3",
      label: "Low",
      children: "Content of Tab Pane 3",
    },
  ];

  return (
    <Dropdown
      menu={notificationProps}
      placement="bottom"
      arrow={{ pointAtCenter: true }}
      trigger={["click"]}
      onOpenChange={handleDropdownVisibleChange}
      dropdownRender={() => {
        return (
          <DropDownNotificaton>
            <NotificationTabs
              defaultActiveKey="1"
              items={tabList}
              onChange={onChangeTab}
            />
          </DropDownNotificaton>
        );
      }}
      // onClick={handleDropdown}
    >
      <div>
        <Badge count={m2mCount > 0 ? m2mCount : ""} size="small">
          <BellOutlined
            style={{ fontSize: "1.4rem", color: "var(--text-primary)", cursor: "pointer" }}
          />
        </Badge>
        {/* <Badge
            count={m2mCount > 0 ? m2mCount : ""}
            size="small"
            color="blue"
            style={{ marginBottom: "1.9rem", marginLeft: "0.5rem" }}
          ></Badge>
          <Badge
            count={m2mCount > 0 ? m2mCount : ""}
            size="small"
            color="green"
            style={{ marginBottom: "1.9rem", marginLeft: "0.1rem" }}
          ></Badge> */}
      </div>
    </Dropdown>
  );
});

export default Notification;
